<template>
 <div>
     <template v-if="viewData ==true">
		<div class="page-top mb-1 mb-3 align-left clearfix">
			<h1> Notifications</h1>
		</div>
		<div class="global-main announcement-main">
			<div class="announcement-inner" v-for="notification in notifications" v-bind:value="notification.id" v-bind:key="notification.id">
				<a href="javascript:;" @click="NotificationView(notification)" >
                <span  class="dropdown-item">
                <div class="anouncement-box mb-3">
					<h2 class="mb-2">  {{ notification.data.sender_name }}</h2>
					<p> {{ notification.created_at }} </p>
					<span class="date mt-2">{{ notification.data.message }} </span>
				</div>
                </span>
                </a>
			</div>
		</div>
     </template>
      <template v-else-if="viewData ==null">
          <preLoader></preLoader>
     </template>
      <template>
     </template>
</div>
</template>
<script>
 export default {
        data() {
            return {
                notifications: null,
                viewData:null,
            }
        },
        mounted(){
           this.allNotifications();
        },
        methods: {
            NotificationView(noti){
             var link = '/' + noti.data.urlRoute;
             this.$router.push(link);
            },
            allNotifications(){
            this.$Progress.start();
               axios.get('/api/viewAllNotifications')
               .then(res => {
                    if(res.status == 200){
                         this.viewData = true;
                        this.notifications = res.data.allNotifications;
                        this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','Some error in your form data');
                    }
                }).then(res => {
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                })
                .catch(err => {
                    this.showAlertBox('error','Some error in your form data');
                });
            }
        },
    }
</script>